module.exports = __webpack_public_path__ + "img/img-9-mobile.929887b5.webp";